import { type EntitlementAddInput, type EntitlementAddSuccess } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { mutationAdd, type AddHookResponse } from '../hooks'
import { useEntitlementCache } from './cache'

export function useAddEntitlements(): AddHookResponse<EntitlementAddInput, EntitlementAddSuccess> {
  const mutation = useTantalimMutation<EntitlementAddInput, EntitlementAddSuccess>({ url: '/entitlement/add' })
  const cache = useEntitlementCache()
  async function add(input: EntitlementAddInput): Promise<EntitlementAddSuccess> {
    const result = await mutation.mutateAsync(input)
    cache.clearList(input.entityId)
    return result
  }
  return mutationAdd(mutation, add)
}
